import { DataGridColSettings } from '@/components/DataGrid/utils';
import { VehicleMaintenanceStatus } from '@/models/vehicle.maintenance';

export const vehicleListDataGridCols: DataGridColSettings[] = [
  {
    field: 'name',
    headerName: 'Vehicle name',
    visible: true,
  },
  {
    field: 'make',
    headerName: 'Make',
    width: 180,
    visible: true,
  },
  {
    field: 'model',
    headerName: 'Model',
    width: 180,
    visible: true,
  },
  {
    field: 'year',
    headerName: 'Year',
    width: 180,
    visible: true,
  },
  {
    field: 'vin',
    headerName: 'VIN Number',
    width: 180,
    visible: true,
  },
  {
    field: 'licensePlate',
    headerName: 'License plate number',
    width: 180,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Vehicle status',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    visible: true,
  },
];

export const vehicleMaintenanceDataGridCols: DataGridColSettings[] = [
  {
    field: 'date',
    headerName: 'Date',
    width: 120,
    visible: true,
  },
  {
    field: 'expirationDate',
    headerName: 'Expiration date',
    width: 120,
    visible: true,
  },
  {
    field: 'maintenanceType',
    headerName: 'Maintenance type',
    width: 150,
    visible: true,
  },
  {
    field: 'description',
    headerName: 'Description',
    visible: true,
  },
  {
    field: 'repairedBy',
    headerName: 'Repaired by',
    width: 180,
    visible: true,
  },
  {
    field: 'cost',
    headerName: 'Cost',
    width: 120,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];

export const maintenanceStatusOptions = [
  { value: VehicleMaintenanceStatus.SCHEDULED, label: 'Scheduled' },
  { value: VehicleMaintenanceStatus.COMPLETED, label: 'Completed' },
];

export const maintenanceStatusLabelMap: Record<
  VehicleMaintenanceStatus,
  string
> = maintenanceStatusOptions.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {} as Record<VehicleMaintenanceStatus, string>);
